<app-back-nav class="d-lg-none d-flex"></app-back-nav> 
<div id="bighome" class="wrapper wrapper_lg air air_horz">
    <div class="row">
        <div class="col-lg-8 l-white">  
            <div class="login ml-lg-10 mt-lg-10">
                <div class="flex-column">
                	<div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->
                	<div class="row mt-8 d-none d-lg-flex ml-1"><!-- ROW -->
	                    <div class="container">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                    
	                        <!-- <button class="btn btn-outline-primary mt-3" routerLink="/officeform">Create Company Profile</button> 
	                        <button class="btn btn-primary mt-3" routerLink="/proform">Create Professional Profile</button>-->
	                        <span class="h3">Create Professional Profile</span>
	                    </div>
	                    <div class="col-2">&nbsp;</div>
	                </div>
	                <div class="row mt-8" *ngIf="hideProfile"> <!-- if hidden -->
	                 	<div class="col-md-1">&nbsp;</div>
	                 	<div class="col-9 errormsg">&nbsp;&nbsp;&nbsp;This profile is hidden for the searches</div>
	                    <div class="col-md-2">&nbsp;</div> 
					</div><!-- END ROW -->
	                <div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->	                 
                    <div class="row mt-8 ml-1"><!-- ROW -->                    
	                    <div class="col-md-1">&nbsp;</div>
	                    <div class="col-md-9">
	                       <div class="form-group">	                    
	                       			<img src="{{proffesional.Image}}" id="Image" style="max-height:500;max-width:500">                     
	                       		<a href="javascript:document.getElementById('profimage').click()" id="camera"><i class="fas fa-camera fa-3x"></i></a> 
	                       		<span class="ml-2">Profile Image </span><br><small>(you can rotate the image after saving)</small>
	                       		<small class="ml-2 errormsg">{{imgerror}}</small>
	                       		<input type="file" name="profimage" class="form-control" id="profimage" accept=".jpeg,.jpg,.png" (change)="loadFile($event)" style="display:none;">
						   </div>
	                    </div>
	                    <div class="col-md-2">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row ml-1"><!-- ROW -->
						<div class="col-1 xs-0">&nbsp;</div> 
	                    <div class="col-md-3 col-xs-7 ">
	                       <div class="form-group">
	                       		<label for="name">First Name</label>
	                       		<input type="text" name="FirstName" class="form-control" id="FirstName" [(ngModel)]="proffesional.FirstName">
	                       		<small class="errormsg" id="FirstName_error">Name is mandatory</small>
						   </div>
	                    </div>
	                     <div class="col-md-2 col-xs-2 ">
	                       <div class="form-group">
	                       		<label for="name">Middle</label>
	                       		<input type="text" name="name" class="form-control" id="middlename" [(ngModel)]="proffesional.Middle">
	                       		
						   </div>
	                    </div>
	                    <div class="col-md-4 col-xs-7">
	                       <div class="form-group">
	                       		<label for="name">Last Name</label>
	                       		<input type="text" name="LastName" class="form-control" id="LastName" [(ngModel)]="proffesional.LastName">
	                       		<small class="errormsg" id="LastName_error">Last Name is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-2 xs-0">&nbsp;</div> 
	                </div><!-- END ROW -->
	                <div class="row ml-1"><!-- ROW --> 
	                	 <div class="col-md-1 col-xs-0">&nbsp;</div>                
	                     <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="mobile">Mobile Phone</label>
	                       		<input type="text" name="Mobile" class="form-control" id="Mobile" mask="(000) 000-0000" [(ngModel)]="proffesional.Mobile">
	                       		<small class="errormsg" id="Mobile_error">Mobile is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="Experience">Active Since</label>
	                       		<select class="form-control" name="Experience" id="Experience" [(ngModel)]="proffesional.Experience">
									<option *ngFor="let year of years" value="{{year}}">{{year}}</option>
						        </select>
	                       		<small class="errormsg" id="Experience_error">Experience is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="hourlyrate">Hourly Rate $</label>
	                       		<input type="number" name="HourlyRate" class="form-control" id="HourlyRate" value="10" step="5" [(ngModel)]="proffesional.HourlyRate">
	                       		<small class="errormsg" id="HourlyRate_error">Hourly Rate is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-2 col-xs-0">&nbsp;</div> 
	                </div><!-- END ROW -->
					 <div class="row ml-1"><!-- ROW -->  
					 <div class="col-md-1 col-xs-0">&nbsp;</div>     
 						<div class="col-md-3 col-xs-5">
	                       <div class="form-group">
	                       		<label for="name">Clinical Specialties</label>&nbsp;<small>(Select all that apply)</small>
	                       		<select class="form-control" name="specialty" id="specialty" (change)="addSpecialtyProp($event)">
	                       			<option>Select</option>
									<option *ngFor="let item of specialties" value="{{item.PkSpecialty}}">{{item.Name}}</option>
	                       		</select>
	                       		<small class="errormsg" id="Specialty_error">At least one clinical or non clinical specialty is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-2 col-xs-5">
	                    	<div class="form-group">
	                    		<span *ngIf="assignedSpecialties.length>0"><b>Selected:</b> {{specLabel}}</span>
	                    	</div>
	                    </div>
	                    <div class="col-md-2 col-xs-5">
	                    	<div class="form-group">
	                    		<p class="text-left">Days Available</p>
	                    		<div class="form-check">
								    <input type="checkbox" class="form-check-input" id="monday" value="m">
								    <label class="form-check-label" for="monday">Monday</label><br>
								    <input type="checkbox" class="form-check-input" id="tuesday" value="t">
								    <label class="form-check-label" for="tuesday">Tuesday</label><br>
								    <input type="checkbox" class="form-check-input" id="wednesday" value="w">
								    <label class="form-check-label" for="wednesday">Wednesday</label><br>
								    <input type="checkbox" class="form-check-input" id="thursday" value="th">
								    <label class="form-check-label" for="thursday">Thursday</label><br>
								    <input type="checkbox" class="form-check-input" id="friday" value="f">
								    <label class="form-check-label" for="friday">Friday</label><br>
								    <input type="checkbox" class="form-check-input" id="saturday" value="s">
								    <label class="form-check-label" for="saturday">Saturday</label><br>  
								  </div>
	                    	</div>
	                    </div>
					</div><!-- END ROW -->
					<div *ngFor="let item of assignedSpecialties, let i = index">
						 <div class="row ml-1"><!-- ROW -->
						 	<div class="col-md-1 col-xs-0">&nbsp;</div> 
		                    <div class="col-md-5">
		                       <div class="form-group">
		                       		<button type="button" class="btn btn-light btn-sm" (click)="removeCat(item.PkSpecialty, i)"><i class="fas fa-trash-alt"></i></button><span>&nbsp;&nbsp;&nbsp;</span>
		                       		<label for="certificate">{{item.Name}} - {{item.Name=='EFDA'?'School Name':'License/Certificate #'}}</label>
		                       		<input type="certificate" name="certificate" class="form-control" id="cert_{{item.PkSpecialty}}" placeholder="{{LicPl}}" value="{{item.License}}">
		                       		<small class="errormsg" id="License_error_{{item.PkSpecialty}}"></small>
							   </div>
		                    </div>
		                    <div class="col-md-4">
		                       <div class="form-group"> 
		                       		<label for="expiration">{{item.Name=='EFDA' || item.Name=='Radiology'?'Issue date':'Valid Through'}}&nbsp;(mm/dd/yyyy)</label>
		                       		<input type="date" name="expiration" class="form-control" id="valid_{{item.PkSpecialty}}"  value="{{item.Valid}}">
		                       		<small class="errormsg" id="Valid_error_{{item.PkSpecialty}}"></small>
							   </div>
		                    </div>
		                    <div class="col-md-2 col-xs-0">&nbsp;</div> 
		                </div><!-- END ROW -->
						 <div class="row ml-1" *ngIf="item.Name!='Radiology' && item.Name!='EFDA'"><!-- ROW -->
						 	<div class="col-md-1 col-xs-0">&nbsp;</div> 
		                    <div class="col-md-5">
		                       <div class="form-group">
		                       		<label for="certificate">{{item.Name}} - Liability/Malpractice policy #</label>
		                       		<input type="liability" name="liability" id="liability_{{item.PkSpecialty}}" class="form-control" id="Liability"  value="{{item.Liability}}">
		                       		
							   </div>
		                    </div>
		                    <div class="col-md-4">
		                       <div class="form-group">
		                       		<label for="expiration">Valid Through (mm/dd/yyyy)</label>
		                       		<input type="date" name="liability_exp" class="form-control" id="liability_exp_{{item.PkSpecialty}}" value="{{item.LiaValid}}">
		                       		
							   </div>
		                    </div>
		                    <div class="col-md-2 col-xs-0">&nbsp;</div> 
		                </div><!-- END ROW -->
					</div>
	                <div class="row ml-1"><!-- ROW -->                    
	                    <div class="col-md-1 col-xs-0">&nbsp;</div> 
	                    <div class="col-md-9">	                    
	                       <div class="form-group">
	                       		<label for="focus">Clinical Subspecialties</label>
	                       		<textarea class="form-control" id="focus" [(ngModel)]="proffesional.Qualifications"></textarea>
						   </div>
	                    </div>
	                    <div class="col-2 xs-0">&nbsp;</div> 
					</div><!-- END ROW -->
					 <div class="row ml-1"><!-- ROW -->
					   <div class="col-md-1 col-xs-0">&nbsp;</div>                 
	                    <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="ncp">Non Clinical Specialties</label>
	                       		<select multiple="5" class="form-control" id="ncp" name="ncp">
	                       			<option *ngFor="let nonspec of nonspecialties" value="{{nonspec.PkSpecialty}}">{{nonspec.Name}}</option>	                       			
	                       		</select>
						   </div>
	                    </div>
	                     <div class="col-md-3">
	                       <div class="form-group">
	                       		<label for="lang">Languages</label><br>
	                       		<select multiple="5" class="form-control" id="lang" name="lang">
	                       			<option *ngFor="let lang of languages" value="{{lang.PkLanguage}}">{{lang.Name}}</option>	                       			
	                       		</select>
	                       		<small class="errormsg" id="Language_error">Select at least 1 language</small>
						   </div>
	                    </div>
	                    <div class="col-4-lg col-8-md col-8-sm">
	                    	<span>Employment Terms</span><br><br>	
	                    	<div class="form-group text-center">	
	                       		<input type="radio" class="form-check-input" name="position" id="position" [checked]="proffesional.Position=='p'" value="p" [(ngModel)]="proffesional.Position">
	                       		<label class="form-check-label" for="hideprofile">Permanent</label><br>
	                       		<input type="radio" class="form-check-input" name="position" id="position" [checked]="proffesional.Position=='t'" value="t" [(ngModel)]="proffesional.Position">
	                       		<label class="form-check-label" for="hideprofile">Temporary</label><br>
	                       		<input type="radio" class="form-check-input" name="position" id="position" [checked]="proffesional.Position=='b'" value="b" [(ngModel)]="proffesional.Position">
	                       		<label class="form-check-label" for="hideprofile">Both&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><br>
	                       	</div>
	                    </div> 	                    
					</div><!-- END ROW -->
					 <div class="row ml-1"><!-- ROW -->
					 	<div class="col-md-1 col-xs-0">&nbsp;</div>                     
	                    <div class="col-md-9">
	                       <div class="form-group">
	                       		<label for="ncs">Non Clinical Subspecialties</label>
	                       		<textarea class="form-control" id="ncs" [(ngModel)]="proffesional.Others"></textarea>
						   </div>
	                    </div>
	                    <div class="col-2">&nbsp;</div> 
					</div><!-- END ROW -->
	                <div class="row mt-8 ml-1"><!-- ROW -->
	                	<div class="col-md-1 col-sm-0 col-xs-0">&nbsp;</div>  
	                    <div class="col-md-7 col-sm-10 col-xs-10">
	                       <div class="form-group">
	                       		<label for="address">Address</label>
	                       		<input type="text" name="Address" class="form-control" id="Address" [(ngModel)]="proffesional.Address"  (change)="onAddress()" autocomplete="new-password">
	                       		<input type="hidden" id="Latitude" name="Latitude" [(ngModel)]="proffesional.Latitude">
	                       		<input type="hidden" id="Longitude" name="Latitude" [(ngModel)]="proffesional.Longitude">
	                       		<small class="errormsg" id="Address_error">Address is mandatory</small>
						   </div>
	                    </div>	                     
	                    <div class="col-md-2">
	                       <div class="form-group">
	                       		<label for="city">Apartment</label>
	                       		<input type="text" name="apartment" class="form-control" id="apartment"  [(ngModel)]="proffesional.Apartment">
						   </div>
	                    </div>
					</div><!-- END ROW -->
					<div class="row ml-1"><!-- ROW -->
						  <div class="col-md-1 col-sm-0 col-xs-0">&nbsp;</div> 
						  <div class="col-md-5">
	                       <div class="form-group">
	                       		<label for="city">City</label>
	                       		<input type="text" name="city" class="form-control" id="city"  [(ngModel)]="proffesional.City">
	                       		<small class="errormsg" id="City_error">City is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-2">
	                       <div class="form-group">
	                       		<label for="state">State</label>
	                       		<select class="form-control" name="state" id="state" [(ngModel)]="proffesional.State">
									<option value="AL">Alabama</option>
						            <option value="AK">Alaska</option>
						            <option value="AZ">Arizona</option>
						            <option value="AR">Arkansas</option>
						            <option value="CA">California</option>
						            <option value="CO">Colorado</option>
						            <option value="CT">Connecticut</option>
						            <option value="DE">Delaware</option>
						            <option value="DC">District Of Columbia</option>
						            <option value="FL" selected>Florida</option>
						            <option value="GA">Georgia</option>
						            <option value="HI">Hawaii</option>
						            <option value="ID">Idaho</option>
						            <option value="IL">Illinois</option>
						            <option value="IN">Indiana</option>
						            <option value="IA">Iowa</option>
						            <option value="KS">Kansas</option>
						            <option value="KY">Kentucky</option>
						            <option value="LA">Louisiana</option>
						            <option value="ME">Maine</option>
						            <option value="MD">Maryland</option>
						            <option value="MA">Massachusetts</option>
						            <option value="MI">Michigan</option>
						            <option value="MN">Minnesota</option>
						            <option value="MS">Mississippi</option>
						            <option value="MO">Missouri</option>
						            <option value="MT">Montana</option>
						            <option value="NE">Nebraska</option>
						            <option value="NV">Nevada</option>
						            <option value="NH">New Hampshire</option>
						            <option value="NJ">New Jersey</option>
						            <option value="NM">New Mexico</option>
						            <option value="NY">New York</option>
						            <option value="NC">North Carolina</option>
						            <option value="ND">North Dakota</option>
						            <option value="OH">Ohio</option>
						            <option value="OK">Oklahoma</option>
						            <option value="OR">Oregon</option>
						            <option value="PA">Pennsylvania</option>
						            <option value="RI">Rhode Island</option>
						            <option value="SC">South Carolina</option>
						            <option value="SD">South Dakota</option>
						            <option value="TN">Tennessee</option>
						            <option value="TX">Texas</option>
						            <option value="UT">Utah</option>
						            <option value="VT">Vermont</option>
						            <option value="VA">Virginia</option>
						            <option value="WA">Washington</option>
						            <option value="WV">West Virginia</option>
						            <option value="WI">Wisconsin</option>
						            <option value="WY">Wyoming</option>
	                       		</select>
	                       		<small class="errormsg" id="State_error">State is mandatory</small>
						   </div>
	                    </div>
	                     <div class="col-md-2">
	                       <div class="form-group">
	                       		<label for="zip">Zip</label>
	                       		<input type="text" name="zip" class="form-control" id="zip" [(ngModel)]="proffesional.Zip">
	                       		<small class="errormsg" id="Zip_error">Zip is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-2">&nbsp;</div> 
	                </div><!-- END ROW -->
	                <div class="row ml-1"><!-- ROW -->
	                	<div class="col-md-1 col-xs-0">&nbsp;</div> 
	                    <div class="col-md-5">
	                       <div class="form-group">
	                       		<label for="email">Email <small><b>(will be used as username)</b></small></label>
	                       		<input type="email" name="email" class="form-control" id="email" [(ngModel)]="user.email" [disabled]="isSameUser">
	                       		<small class="errormsg" id="email_error">Email is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-4">
	                       <div class="form-group">
	                       		<label for="password">Password</label>
	                       		<input type="password" name="password" class="form-control" id="password" [(ngModel)]="user.password"  [disabled]="isSameUser">
	                       		<small class="errormsg" id="password_error">Password is mandatory</small>
						   </div>
	                    </div>
	                    <div class="col-md-2 col-xs-0">&nbsp;</div> 
	                </div><!-- END ROW -->	               	                
	                 <div class="row ml-1"><!-- ROW -->
	                	<div class="col-md-1 col-xs-0">&nbsp;</div> 
	                    <div class="col-md-9">	                       
	                       	<span class="text-right"><b>Professional Association</b>&nbsp;&nbsp;</span>
	                      <select name="Institution" [(ngModel)]="proffesional.FkInstitution">
	                       			<option value="0">None</option>
	                       			<option value="1">DSGO</option>
	                       		</select>
	                    </div>
	                    <div class="col-md-2 col-xs-0">&nbsp;</div> 
	                </div><!-- END ROW -->	        
	                <div class="row ml-1 mt-4"><!-- ROW -->   
	                	<div class="col-md-1 col-xs-0">&nbsp;</div>                  
	                    <div class="col-md-9">
	                       <div class="form-group">	                 			
	                       		<label for="files">Attach CV, Certificates, Licenses, Liability Policies, Etc. MUST be a PDF</label><br>
								<div *ngIf="currentfiles.length>0">
									<table class="table">
										  <thead>
										    <tr>
										      <th scope="col">Filename</th>
										      <th scope="col">View</th>
										      <th scope="col">Delete</th>
										    </tr>
										  </thead>
										  <tbody>
										    <tr *ngFor="let item of currentfiles">
										      <td>{{item.Name}}</td>
										      <td><a href="assets/img/cvs/readfile.php?file={{proffesional.PkProffesional}}/{{item.Name}}" target="_new"><i class="fas fa-eye" style="color:#000000"></i></a></td>
										      <td><i class="fa fa-trash-alt" (click)="deleteFile(item.PkFile)"></i></td>
										    </tr>										   
										  </tbody>
										</table>
		                       	</div>
	                       		<input type="file" accept=".pdf" name="cvfile" class="form-control" id="cvfile" (change)="storePdf($event)" multiple>
						   </div>
	                    </div>
	                    <div class="col-2">&nbsp;</div> 
					</div><!-- END ROW -->
					 <div class="row ml-1"  *ngIf="this.proffesional.PkProffesional>0"><!-- ROW -->   
	                	<div class="col-md-1 col-xs-0">&nbsp;</div>                  
	                    <div class="col-md-4">
	                       <div class="form-check">                     
	                       		<input type="checkbox" class="form-check-input" id="hideprofile" (change)="confirmHide($event)" [checked]="hideProfile">
	                       		<label class="form-check-label" for="hideprofile">Hide Profile</label>
						   </div>
						</div>
						 <div class="col-md-5">
						    <div class="form-check" *ngIf="isAdmin">                     
	                       		<button class="btn btn-outline-secondary" (click)="confirmDelete()">Delete Profile</button>
	                       	</div>	                       	
	                    </div>
	                    <div class="col-2">&nbsp;</div> 
					</div><!-- END ROW -->
					<div class="row mt-8">
						<div class="col-md-1 col-xs-0">&nbsp;</div> 
						 <div class="col-md-9">
							<div id="c-alerts__area"></div>
							<p class="errormsg text-center">{{generalError}}</p>
							<button class="btn w-100 btn-secondary" (click)="save()">{{action}} Professional Profile</button>	
							<p class="text-center"><small class="text-muted">By clicking this button you agree to TransForma's <a href="javascript:void(0)" data-toggle="modal" data-target="#disclaimer">Policy and terms of use</a></small></p>							
		              </div>
		              <div class="col-md-2 col-xs-0">&nbsp;</div> 
					</div> <!-- separa -->
					<div class="row mt-8"><div class="col-12">&nbsp;</div></div> <!-- separa -->
                </div>
            </div>
        </div>
        <div class="flex-column col-lg-4 l-grey d-none d-lg-flex">
        	 <p>&nbsp;</p>
             <p>&nbsp;</p>
           <app-login-form></app-login-form>          
        <div>
    </div>
</div>
<app-footer class="d-none d-lg-block"></app-footer>

<div class="modal" tabindex="-1" role="dialog" id="disclaimer">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">TransForma Terms and Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Welcome to <strong>TransForma Connect</strong>, the service for Dental Service Organizations (DSO’s), and Multi &amp; Single Practice Dental Organizations to identify and contact Clinical &amp; Non Clinical Professionals, operated by TransForma, LLC.</p>

<p>By accessing <strong>TransForma Connect</strong> via <a href="http://TransForma.us">TransForma.us</a>, <a href="http://TransForma.us/connect">TransForma.us/connect</a>, or <a href="http://transformaconnect.com">TransFormaConnect.com</a>, you agree to be bound by the Terms of Use (this agreement), whether or not you register as a member. If you wish to become a member and make use of the <strong>TransForma Connect</strong> service, please read these Terms of Use. The term "Website" is deemed to refer to using of the Service by means of a computer, a mobile device, or a mobile application.</p>

<ol>
	<li><strong>Acceptance of Terms of Use Agreement.</strong>

	<ul>
		<li>This Agreement is an electronic contract that establishes the legally binding terms you must accept to use the Website and to become a "Member." For purposes of this Agreement, the term "Member" means a person who provides information to TransForma, LLC on the Website or to participate in the Service in any manner, whether such person uses the Service as a free member or a subscriber. You acknowledge and agree that Members of <strong>TransForma Connect</strong> will be part an online directory&nbsp; owned by TransForma, LLC, and that Professional profiles on the Website will be viewable by paying Company subscribers who will be able to communicate directly with Professional subscribers.</li>
		<li>By accessing the Website or using the Service, you accept this Agreement and agree to the terms, conditions, and notices contained or referenced herein and consent to have this Agreement and all notices provided to you in electronic form. This Agreement may be modified by TransForma, LLC from time to time, such modifications to be effective upon posting by TransForma, LLC on the <strong>TransForma Connect</strong> websites.</li>
		<li>By using the Service, you consent to receive this Agreement in electronic form. To withdraw this consent, you must cease using the Service and terminate your account.</li>
	</ul>
	</li>
	<li><strong>Eligibility.</strong>
	<ul>
		<li>By accessing and using the Website, you represent and warrant that you have the right, authority, and capacity to enter into this Agreement and to abide by all of the terms and conditions of this Agreement. If you become a Member, you represent and warrant that you possess the credentials as stated in your profile. If you use the Service from outside of the United States, you are responsible for complying with the laws and regulations of the territory from which you access or use the Website and Service.</li>
	</ul>
	</li>
	<li><strong>Term and Termination.</strong>
	<ul>
		<li>This Agreement will remain in full force and effect while you use the Service and/or are a Member.</li>
		<li>You may change or cancel your membership at any time, for any reason, by pressing the “unsubscribe profile” link on the bottom of the profile page. If you cancel your membership, we ask that you provide a reason for your cancellation. If you cancel your subscription, TransForma, LLC requires a reasonable amount of time to process the action. If you cancel a subscription, you will enjoy subscription benefits until the end of your then-current subscription commitment, following which your subscription benefits will expire. However, in no event will you be eligible for a refund of any portion of the subscription fees paid for the then-current subscription commitment. Canceling a subscription does not automatically cancel your membership. If you are a subscriber and you cancel your subscription but not your membership, unless you elect to hide your profile, you will continue to be a Member in the Service and Companies may view your profile. If you hide your profile, Companies will not be able to view your profile until you "unhide" your profile. If you cancel your membership, your profile will be removed, and Companies will not be able to view your profile. You will be able to use your current registration information to "unhide" your profile and reactivate your membership for an unspecified period. A Member can hide their profile or cancel their membership and remove their profile at any time by following the instructions contained on the "Account Settings" page on the Website.</li>
		<li>TransForma, LLC may terminate or suspend your subscription and/or membership in the Service at any time without notice if TransForma, LLC believes that you have breached this Agreement, including, but not limited to, by using the Website and Service for fraudulent use, engaging in prohibited or inappropriate communications or activities, and any breach of your representations and warranties. Upon such termination or suspension, you will not be entitled to a refund of any unused subscription fees, if applicable. TransForma, LLC is not required to disclose, and may be prohibited by law from disclosing, the reason for the termination or suspension of your account.</li>
		<li>After your membership or subscription is terminated for any reason, all terms of this Agreement survive such termination, and continue in full force and effect, except for any terms that by their nature expire or are fully satisfied.</li>
	</ul>
	</li>
	<li><strong>Limitation o</strong><strong>f Liability.</strong>
	<ul>
		<li>To the fullest extent allowed by applicable law, in no event will TransForma, LLC, its affiliates, business partners, licensors, or service providers be liable to you or any third party for any indirect, reliance, consequential, exemplary, incidental, special, or punitive damages, including, without limitation, damages for loss or corruption of data or programs, service interruptions, and procurement of substitute services, even if TransForma, LLC has been advised of the possibility of such damages. Notwithstanding anything to the contrary contained herein, TransForma LLC's liability to you for any cause whatsoever, and regardless of the form of the action, will at all times be limited to the amount paid, if any, by you to TransForma, LLC for the service during the term of membership. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to the use of the Website or Service or the terms of this Agreement is forever null and void.</li>
	</ul>
	</li>
	<li><strong>Indemnity by You.</strong>
	<ul>
		<li>You agree to indemnify and hold TransForma, LLC, its subsidiaries &amp; affiliates, and its and their officers, agents, partners, and employees, harmless from any loss, liability, claim, or demand, including reasonable attorney's fees, made by any third party due to or arising out of your breach of or failure to comply with this Agreement, including any breach of your representations and warranties contained herein, any information or content you enter on the Website or as a result of the Service, and the violation of any law or regulation by you. TransForma, LLC reserves the right to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with the TransForma, LLC in connection therewith.</li>
	</ul>
	</li>
	<li><strong>Entire Agreement; Other.</strong>
	<ul>
		<li>This Agreement, with any guidelines or rules that are separately posted for services on the Website, contains the entire agreement between you and TransForma, LLC regarding the use of the Website and/or the Service. If any provision of this Agreement is held invalid, the remainder of this Agreement shall continue in full force and effect. The failure of TransForma, LLC to exercise or enforce any right or provision of this Agreement shall not constitute a waiver of such right or provision. You agree that your online account is non-transferable and all of your rights to your profile or contents within your account terminate upon your death. No agency, partnership, joint venture, or employment with TransForma, LLC is created as a result of this Agreement and you may not make any representations or bind TransForma, LLC in any manner.</li>
	</ul>
	</li>
</ol>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="unsubscribe" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Unsubscribe from service</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
	      <div class="col-md-8 col-xs-4">Are you sure you want to unsubscribe?</div>
	    </div>
	    <div class="row">
	      <div class="col-md-12 col-xs-4">
	      	<div class="form-group">
           		<label for="unsubs">Can you give us a reason?</label>
           		<textarea class="form-control" id="unsubs" [(ngModel)]="reason"></textarea>
		   </div>
	      </div>
	    </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="unsubscribe()">Send</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="hidecannot" tabindex="-1" role="dialog" aria-labelledby="hide profile" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Edit profile</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
	      <div class="col-md-8 col-xs-4">In order to edit your profile you need to make it visible again.</div>
	    </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary"  data-dismiss="modal" (click)="makeVisible()">Make visible</button>
      </div>
    </div>
  </div>
</div>